import { linkSpell } from '../tools';
/**
 * 转换接口协议
 * @param {string} protocolName
 * @param {object} data
 * @returns Promise
 */

var protocolHandle = function protocolHandle(protocolName, data) {
  return new Promise(function (resolve, reject) {
    // let url = 'https://applink.feishu.cn';
    var url = 'lark://applink.feishu.cn';
    if (typeof protocolName !== 'string') return reject({
      err_msg: protocolName + ':fail_not_config'
    });
    url += protocolName.indexOf('/') === 0 ? protocolName : '/' + protocolName;
    url = linkSpell(url, data);
    window.location.href = url; // window.open(url)

    resolve(url);
  });
};

export default protocolHandle;